import React from 'react'
import HomeTemplate from '../../templates/Home/HomeTemplate'

const Home = () => {
  return (
    <HomeTemplate />
  )
}

export default Home